<div id="loading-order" class="popup-comp data-loader" role="dialog">
  <p class="reserve-text" *ngIf="data !== 'processingFile' && data !== 'processingRequest'">{{ "accountOverview.loader.loadingData" | cxTranslate }}</p>
  <p class="reserve-text" *ngIf="data === 'processingFile'">Processing file</p>
  <p class="reserve-text" *ngIf="data === 'processingRequest'">Processing your request</p>
  <div class="progress2 progress-moved">
    <div class="progress-bar2"></div>
  </div>
</div>